import React from "react";
import { useSelector } from "react-redux";

import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";

import PlayBtn from "../../../../assets/images/icons/play-icon.png";

import { useNavigate } from "react-router-dom";
import BackIcon from "../../../../assets/svg/BackIcon";
import { VimplayData } from "../../../../lib/data/vimplay.data";

const Vimplay = () => {
  const navigate = useNavigate();

  const { isAuth } = useSelector((state) => state.auth);
  return (
    <div>
      <div>
        <HeaderAfterLogin />
      </div>

      <main className="main mt-4">
        <div className="casinoProvidersGames games-section container-fluid">
          <div className="games-section">
            <div className="d-flex justify-content-between">
              <h2 className="sectionTitle">Vimplay</h2>
              <div className="back-link" onClick={() => navigate(-1)}>
                Back <BackIcon />
              </div>
            </div>
            <ul className="mt-4">
              {Object.values(VimplayData).map((item) => {
                return (
                  <li className="game-section">
                    <a href={isAuth ? item.redirectUrl : "/login"}>
                      <img src={item.imgUrl} />
                      <div className="play-btn">
                        <img src={PlayBtn} alt="PlayIcon" />
                      </div>
                      <div className="name">{item.name}</div>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </main>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Vimplay;
